<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Pedidos en proceso</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Pedidos en proceso</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-lg-6 col-12">
                <app-lista-pedidos label="Recepcionados" (updateData)="getData()" [rows]="rowsRecepcionados"
                    [tempRows]="rowsRecepcionados" [mini]="true" [sortByKey]="'fecha_termino'" [reverseSort]="false"
                    [isLoading]="isLoadingRecepcionados"></app-lista-pedidos>
            </div>
            <div class="col-lg-6 col-12 mt-lg-0 mt-2">
                <app-lista-pedidos label="En Proceso" (updateData)="getData()" [rows]="rowsEnProceso" [sortByKey]="'fecha_termino'" [reverseSort]="false"
                    [tempRows]="rowsEnProceso" [mini]="true" [isLoading]="isLoadingEnProceso"></app-lista-pedidos>
            </div>
        </div>
    </div>
</section>